import PlannerMode from './Planner.mode';

const AgentMode = {
    planner: PlannerMode,
};

export default AgentMode;
